import { z } from "zod";

export const sortColumnOptions = [
  "NAME",
  "EQUIPMENT_TYPE",
  "DISPLAY_ORDER",
  "CREATED_AT",
] as const;

export const searchSchema = z.object({
  freeText: z.string().default(""),
  showDisabled: z.boolean().default(false),
  equipmentTypeId: z.string().optional(),
  sortColumn: z.enum(sortColumnOptions).default("DISPLAY_ORDER"),
  sortOrder: z.enum(["ASC", "DESC"]).default("ASC"),
});
